import React, { useState } from 'react';
import './SignUp.css';

export default function SignUp() {
	const [formData, setFormData] = useState({
		email: '',
		fitnessGoals: '',
		healthIssues: ''
	});

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	return (
		<div className='signup-container'>
			<div className='signup-card'>
				<h1>Get Your Workout Plan</h1>
				<p>Tell us about yourself and we'll generate a personalized workout plan for you.</p>
				<form className='signup-form'>
					<div className='form-group'>
						<label htmlFor='email'>Email Address</label>
						<input
							type='email'
							id='email'
							name='email'
							placeholder='you@example.com'
							value={formData.email}
							onChange={handleChange}
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='fitnessGoals'>Fitness Goals</label>
						<textarea
							id='fitnessGoals'
							name='fitnessGoals'
							placeholder='e.g. Build muscle, lose weight, improve endurance...'
							rows={4}
							value={formData.fitnessGoals}
							onChange={handleChange}
						/>
					</div>
					<div className='form-group'>
						<label htmlFor='healthIssues'>Health Issues or Injuries</label>
						<textarea
							id='healthIssues'
							name='healthIssues'
							placeholder='e.g. Lower back pain, bad knees, none...'
							rows={3}
							value={formData.healthIssues}
							onChange={handleChange}
						/>
					</div>
					<button type='submit' className='signup-btn'>Generate My Plan</button>
				</form>
			</div>
		</div>
	);
}
